import { SimpleGrid } from "@mantine/core";
import { profitColor } from "constants/common/report";
import { ProfitSummaryCardsProps, SummaryCardProps } from "constants/types/report";
import { FC } from "react";
import { formatCurrency } from "utils/helpers/format";
import SummaryCard from "../SummaryCard";

const ProfitSummaryCards: FC<ProfitSummaryCardsProps> = ({ summary }) => {
  const cards: SummaryCardProps[] = [
    { label: "Số đơn", value: `${summary.orderCount} đơn` },
    { label: "Tổng doanh thu", value: formatCurrency(summary.totalRevenue) },
    { label: "Tổng giá vốn", value: formatCurrency(summary.totalCost) },
    { label: "Đã thu", value: formatCurrency(summary.totalPaid) },
    {
      label: "Còn lại",
      value: formatCurrency(summary.totalRemaining),
      color: summary.totalRemaining > 0 ? "orange" : undefined,
    },
    {
      label: "Lợi nhuận",
      value: formatCurrency(summary.totalGrossProfit),
      color: profitColor(summary.totalGrossProfit),
    },
    {
      label: "Lợi nhuận thực thu",
      value: formatCurrency(summary.totalRealizedProfit),
      color: profitColor(summary.totalRealizedProfit),
    },
  ];

  return (
    <SimpleGrid cols={{ base: 2, sm: 3, md: 4, lg: 7 }} spacing="sm">
      {cards.map((card) => (
        <SummaryCard key={card.label} {...card} />
      ))}
    </SimpleGrid>
  );
};

export default ProfitSummaryCards;
